/* tslint:disable */
/* eslint-disable */
export enum ApplicationChannelTypeEnum {
  CustomerLed = 'CustomerLed',
  DealerLed = 'DealerLed',
  BrokerLed = 'BrokerLed'
}
